<template>
  <div class="container">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>酒店列表</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>
    <div class="stadium_tip">注：由于季节变化或酒店健身中心经营原因，酒店数量会根据实际情况有所调整和更新，同时每月酒店上新会发布推文通知</div>
    <div v-if='blackviper==0'>
      <div v-for="(item,index) in city" class="stadium">
        <div class="stadium_title">{{item}}</div>
        <div class="stadium_item" v-for="(item_stadium,index_stadium) in stadium" v-show="item_stadium.city==item && item_stadium.is_black_vip==0">
          {{item_stadium.name}}
        </div>
      </div>
    </div>
    <div v-else>
      <div v-for="(item,index) in city" class="stadium">
        <div class="stadium_title">{{item}}</div>
        <div class="stadium_item" v-for="(item_stadium,index_stadium) in stadium" v-show="item_stadium.city==item">
          {{item_stadium.name}}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        city:[],
        blackviper:0
      }
    },
    created() {
      console.log(this.$route.params)
      console.log(this.$route.params.type)
      if(this.$route.params.type=='4'||this.$route.params.type==4){
        this.blackviper=1
      }else{
        this.blackviper=0
      }
      // if(this.$route.params.type=='4'||this.$route.params.type==4){
      //   this.title='黑金会员'
      // }else if(this.$route.params.type=='3'||this.$route.params.type==3){
      //   this.title='钻石会员'
      // }else if(this.$route.params.type=='2'||this.$route.params.type==2){
      //   this.title='铂金会员'
      // }else if(this.$route.params.type=='1'||this.$route.params.type==1){
      //   this.title='黄金会员'
      // }else{
      //   this.title='黑金会员'
      // }
      this.FLLoadStadiumList()
    },
    watch: { },
    mounted() { },
    methods: {
      unique(arr) {
        return Array.from(new Set(arr))
      },
      FLLoadStadiumList(){
        var $this = this
        let param = { }
        var qs = require('qs');
        let url = this.api.userApi.flStadiumLists
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          console.log(result)
          if (result.code==0) {

            $this.stadium=result.data.stadiums
            var citytemp=[]
            for (var i = 0; i < result.data.stadiums.length; i++) {
              citytemp.push(result.data.stadiums[i].city)
            }
            console.log(citytemp)
            console.log($this.unique(citytemp))
            $this.city=$this.unique(citytemp)
          }
        }).catch((error) => {
          console.warn(error)
        })
      },
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .container{
    padding-bottom: 50*@vm_base;
  }
  .stadium_tip{
    width: 100%;
    padding: 40*@vm_base 40*@vm_base 0 40*@vm_base;
    font-size: 26*@vm_base;
    line-height: 1.8;
    color: #c9914b;
  }
  .stadium{
    width: 100%;
    // border: 1px solid red;
    padding: 40*@vm_base 20*@vm_base 0 20*@vm_base;
    .stadium_title{
      width: 100%;
      background: #EEEEEE;
      padding: 20*@vm_base 20*@vm_base;
    }
    .stadium_item{
      width: 100%;
      line-height: 2;
      padding: 0 20*@vm_base;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/vip/allstadium.vue